export default "__VITE_ASSET__CPw5dNa___"